import { GET_MERN_PRODUCTS, MERN_LOADING, MERN_PRODUCTS_ERROR } from "../types";

const ProductReducer = (state, action) => {
  switch (action.type) {
    case GET_MERN_PRODUCTS:
      return {
        ...state,
        mern_products: action.payload,
        mern_loading: false,
      };

    case MERN_LOADING:
      return { ...state, mern_loading: true };

    case MERN_PRODUCTS_ERROR:
      return {
        ...state,
        mern_error: action.payload,
      };

    default:
      return state;
  }
};

export default ProductReducer;